<template>
<!-- eslint-disable -->
  <div class="privacy_policy">
    <h3 class="privacy_policy__title">Polityka prywatności i zasady dotyczące cookies</h3>
    <div class="privacy_policy__content">
      <h4>I. INFORMACJE OGÓLNE</h4>
      <p>
        Prywatność Użytkowników korzystających z serwisu Early Stage Online (dalej: <span class="font-bold">„Serwis”</span>), dostępnego na stronie online.earlystage.pl jest dla nas bardzo ważna, w związku z czym dokładamy wszelkich starań, aby ją chronić. Niniejszy dokument opisuje sposoby przetwarzania oraz ochrony danych osobowych dotyczących Użytkowników w związku z korzystaniem przez nich z Serwisu, jak również określa Zasady Dotyczące Cookies.
      </p>
      <p>
        Niniejsza Polityka Prywatności i Zasady Dotyczące Cookies powiązane są z „Regulaminem świadczenia usług drogą elektroniczna za pośrednictwem Serwisu” również dostępnym na stronie online.earlystage.pl (dalej: <span class="font-bold">„Regulamin”</span>).
      </p>
      <h4>II. DEFINICJE</h4>
      <p>
        <span class="font-bold">II.1.</span>W przypadku, gdy w niniejszym dokumencie używane będą następujące pojęcia pisane wielką literą, będą miały one znaczenie przypisane im poniżej, chyba z danego postanowienia będzie wynikało, co innego:
      </p>

      <p>
        <span class="font-bold">II.2.</span> 
        <span class="font-bold"> Administrator</span> - ES EDUCATION BOCHIŃSKA I WSPÓLNICY Spółka komandytowa, zwana dalej również „Early Stage”, wpisana do rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla miasta st. Warszawy XIII Wydział Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS: 0000883647, ul. Plac Thomasa Woodrowa Wilsona 4 /15, 01 – 626 Warszawa, NIP: 5252852107, REGON: 38822625500000, adres e-mail: <a href="mailto:es.online@earlystage.pl">es.online@earlystage.pl</a>. Administrator przetwarza Dane osobowe Użytkownika w postaci jego adresu e-mail oraz Hasła, podawanych przez Użytkownika w trakcie korzystania z Serwisu, jak również dane zapisane w Linku (w rozumieniu Regulaminu), dane dotyczące adresu IP urządzenia końcowego Użytkownika i dane zawarte w plikach cookies, jako administrator Danych osobowych w rozumieniu Rozporządzenia, natomiast pozostałe Dane osobowe Użytkownika (w tym jego adres e-mail przekazany przez Szkołę w celach weryfikacyjnych), jako podmiot przetwarzający w rozumieniu Rozporządzenia, działający w imieniu Szkoły;
      </p>

      <p>
        <span class="font-bold">II.3.</span> <span class="font-bold"> Dane osobowe</span> - oznaczają wszelkie informacje o zidentyfikowanej lub możliwej do zidentyfikowania osobie fizycznej („osobie, której dane dotyczą”); możliwa do zidentyfikowania osoba fizyczna to osoba, którą można bezpośrednio lub pośrednio zidentyfikować, w szczególności na podstawie identyfikatora takiego jak imię i nazwisko, numer identyfikacyjny, Link w rozumieniu Regulaminu, dane o lokalizacji, identyfikator internetowy, w tym IP urządzenia, wersja przeglądarki z jakiej Użytkownik korzystał, system operacyjny oraz typ/nazwa urządzenia Użytkownika, inne informacje gromadzone za pośrednictwem plików cookies lub jeden bądź kilka szczególnych czynników określających fizyczną, fizjologiczną, genetyczną, psychiczną, ekonomiczną, kulturową lub społeczną tożsamość osoby fizycznej;
      </p>

      <p><span class="font-bold">II.4.</span> <span class="font-bold"> Polityka prywatności</span> – niniejszy dokument dotyczący prywatności i plików cookies;</p>

      <p><span class="font-bold">II.5.</span> <span class="font-bold"> Profil</span> - sekcja (zbiór informacji przechowywanych w systemie teleinformatycznym
      Usługodawcy dotyczących danego Użytkownika) dostępna w Serwisie, w której
      zarejestrowani Użytkownicy będą mogli uzyskać Treści (zgodnie z definicją zawartą w
      Regulaminie) oraz dostęp do funkcjonalności Serwisu na zasadach opisanych w Regulaminie,
      którego treść jest dostępna w Serwisie;</p>

      <p><span class="font-bold">II.6.</span> <span class="font-bold"> Rozporządzenie</span> - Rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 z
      dnia 27 kwietnia 2016 roku w sprawie ochrony osób fizycznych w związku z przetwarzaniem
      danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia
      dyrektywy 95/46/WE;</p>

      <p><span class="font-bold">II.7.</span> <span class="font-bold"> Serwis</span> – serwis internetowy przeznaczony dla Użytkowników, prowadzony przez
      Administratora pod adresem www.online.earlystage.pl</p>

      <p><span class="font-bold">II.8.</span> <span class="font-bold"> Użytkownik</span> – osoba fizyczna odwiedzająca Serwis i korzystająca z usług oraz
      funkcjonalności Serwisu opisanych w Regulaminie lub w Polityce prywatności. Korzystanie z
      w/w usług oraz funkcjonalności możliwe jest albo za pośrednictwem specjalnego Linku
      (zgodnie z definicją zawartą w Regulaminie) posiadanego przez Użytkownika, albo po
      zrejestrowaniu się przez Użytkownika w Serwisie, za pośrednictwem jego Profilu - w zależności
      od rodzaju usług i funkcjonalności, z których Użytkownik korzysta - z zastrzeżeniem
      postanowień Regulaminu w zakresie nadania przez Użytkownika uprawnień do dostępu do
      Profilu przez osoby trzecie. Do osób, którym Użytkownik nadał w/w uprawnienia dostępowe,
      stosuje się w sposób odpowiedni postanowienia niniejszej Polityki prywatności.</p>

      <p><span class="font-bold">II.9.</span> <span class="font-bold"> Szkoła</span> – podmiot, z którym Użytkownik zamierza zawrzeć lub zawarł umowę o
      przeprowadzenie kursu językowego, która przekazuje Administratorowi Dane osobowe na
      podstawie stosownych umów powierzenia przetwarzania danych osobowych.</p>

      <h4>III. CELE I PODSTAWY PRZETWARZANIA DANYCH OSOBOWYCH</h4>

      <p><span class="font-bold">III.1. </span> Dane osobowe Użytkowników przetwarzane są przez Administratora na różnych
      podstawach i w różnych celach, w zależności od tego z jakich funkcjonalności Serwisu
      Użytkownik korzysta. Poniżej znajduje się opis tych celów i podstaw prawnych przetwarzania
      danych.</p>

      <p>Aktywność Użytkownika w Serwisie, w tym jego Dane osobowe, są rejestrowane w logach
      systemowych (programie komputerowym, w którym zapisuje się informacje o zdarzeniach i
      działaniach systemu informatycznego za pośrednictwem którego Administratora świadczy 
      usługi drogą elektroniczną) i przetwarzane w celach związanych ze świadczeniem usług przez
      Administratora, w celach: technicznych, administracyjnych, zapewnienia bezpieczeństwa i
      zarządzania systemu informatycznego.,.</p>

      <p><span class="font-bold">III.2. </span> Przetwarzanie danych osobowych Użytkowników w celu korzystania z funkcjonalności
      Serwisu, w tym w celu rejestracji w Serwisie i uzyskania dostępu do Profilu: Użytkownik
      korzysta z Serwisu jako Użytkownik poprzez funkcjonalności Serwisu, w tym dostępne w jego
      Profilu i w związku z tym jego Dane osobowe podane w trakcie rejestracji w Serwisie tj. adres
      e-mail oraz Hasło, a niezbędne do obsługi i korzystania z Profilu, jak również dane zapisane
      w Linku (w rozumieniu Regulaminu) są przetwarzane przez Administratora w następujących
      celach i na następujących podstawach prawnych:</p>

      <div>
        <p>
          <span class="font-bold">a)</span> w celu świadczenia przez Administratora usług drogą elektroniczną w zakresie
          określonym w Regulaminie, gdyż jest to niezbędne do wykonania umowy o
          świadczenie usług drogą elektroniczną (podstawa prawna - art. 6 ust. 1 lit. b
          Rozporządzenia);
        </p>
        <p>
          <span class="font-bold">b)</span> w celu ewentualnego ustalenia i dochodzenia roszczeń lub obrony przed roszczeniami
          Użytkownika na podstawie prawnie uzasadnionego interesu Administratora, jakim jest
          ochrona jego praw (podstawa prawna - art. 6 ust. 1 lit. f Rozporządzenia);
        </p>
        <p>
          <span class="font-bold">c)</span> w celach marketingowych Administratora oraz innych podmiotów na zasadach, w celach i na podstawach określonych w pkt III.4 poniżej;<br>Podanie Danych osobowych przez Użytkownika nie jest wymogiem ustawowym lub umownym. Podanie danych, które w trakcie procesu rejestracji w Serwisie są oznaczone jako obowiązkowe jest wymagane w celu obsługi i korzystania z Profilu, a ich niepodanie skutkuje brakiem możliwości uzyskania dostępu i korzystania z Profilu w Serwisie. Podanie innych danych jest dobrowolne, nie jest wymogiem ustawowym lub umownym – Użytkownik podając te dane wyraża zgodę na ich przetwarzanie; będą one wtedy przewarzane na podstawie art. 6 ust. 1 lit. a) Rozporządzenia.
        </p>
      </div>

        <p>
          <span class="font-bold">III.3. </span><u>Przetwarzanie Danych osobowych Użytkowników, w zakresie Danych osobowych podanych w celu zawarcia ze Szkołą umowy o przeprowadzenie kursu językowego oraz w zakresie Danych osobowych udostępnianych Użytkownikowi w Profilu:</u>Wskazane Dane osobowe przetwarzane są przez Administratora na podstawie stosownych umów powierzenia przetwarzania danych osobowych; administratorem tych Danych osobowych jest Szkoła. Użytkownik uzyskuje informacje na temat zasad przetwarzania Danych osobowych przez Szkołę w trakcie procesu zawierania ze Szkołą umowy o przeprowadzenie kursu językowego.
        </p>
        <p>
          <span class="font-bold">III.4. </span><u>Przetwarzanie Danych osobowych Użytkowników w celach marketingowych:</u>
          Działania marketingowe, jakie może podejmować Administrator mogą obejmować:
        </p>
        <div>
          <p>
            <span class="font-bold">a)</span> reklamę kontekstową (wyświetlanie treści marketingowych, które nie są dostosowane
            do preferencji Użytkownika) i w związku z tym Administrator może przetwarzać Dane
            osobowe Użytkownika w tym celu i na podstawie uzasadnionego interesu
            Administratora (podstawa prawna - art. 6 ust. 1 lit. f Rozporządzenia);
          </p>
          <p>
            <span class="font-bold">b)</span> kierowanie do Użytkowników, którzy w tym celu podali swój adres e-mail, e-mailowych
            powiadomień o ofertach lub treściach, w tym na zasadach określonych w
            Regulaminie, które to informacje lub treści mogą zawierać informacje handlowe
            (usługa newslettera) i w związku z tym Administrator może przetwarzać Dane
            osobowe Użytkownika (adres e-mail Użytkownika) w następujących celach i na
            podstawie:
          </p>
          <div>
            <p>
              <span class="font-bold">-</span> świadczenia usługi wysyłki newslettera, gdyż jest to niezbędne do wykonania umowy o świadczeniu usług drogą elektroniczną (podstawa prawna - art. 6
            ust. 1 lit. b Rozporządzenia);
            </p>
            <p>
              <span class="font-bold">-</span> kierowania do Użytkownika treści marketingowych w ramach newslettera w ramach prawnie uzasadnionego interesu Administratora (podstawa prawna - art. 6 ust. 1 lit. f Rozporządzenia) lub w granicach udzielonej przez Użytkownika        odrębnej zgody (podstawa prawna - art. 6 ust. 1 lit. a Rozporządzenia);
            </p>
            <p>
              <span class="font-bold">-</span> w celu ewentualnego ustalenia i dochodzenia roszczeń lub obrony przed roszczeniami Użytkownika na podstawie prawnie uzasadnionego interesu Administratora, jakim jest ochrona jego praw (podstawa prawna - art. 6 ust. 1 lit. f Rozporządzenia);
            </p>
            <p>
              <span class="font-bold">-</span> innego rodzaju działania związane z marketingiem bezpośrednim towarów i usług (przesyłanie informacji handlowych drogą elektroniczną oraz działania telemarketingowe) w ramach prawnie uzasadnionego interesu Administratora (podstawa prawna art. 6 ust. 1 lit. f Rozporządzenia) lub w granicach udzielonej przez Użytkownika odrębnej zgody (marketing bezpośredni, podstawa prawna - art. 6 ust. 1 lit. a Rozporządzenia).
            </p>
          </div>
      </div>
      <p>  
        Podanie Danych osobowych przez Użytkownika nie jest wymogiem ustawowym lub umownym. Podanie Danych osobowych w zakresie adresu e-mail jest dobrowolne, ale niezbędne w celu świadczenia usługi newslettera, a ich niepodanie skutkuje brakiem możliwości jego wysyłki.
      </p>

      <p>
        <span class="font-bold">III.5. </span><u>Przetwarzanie Danych osobowych Użytkowników odwiedzających profile Administratora prowadzone w mediach społecznościowych:</u> W przypadku, gdy Użytkownik odwiedza publiczne profile Administratora prowadzone w mediach społecznościowych (Facebook, Instagram). Administrator przetwarza Dane osobowe Użytkowników w związku z  prowadzeniem profilu Administratora, w tym w celu umożliwienia Użytkownikom aktywności na tych profilach oraz informowania Użytkowników o aktywnościach Administratora i promowania różnego rodzaju wydarzeń, usług oraz produktów na podstawie prawnie uzasadnionego interesu Administratora polegającego na promowaniu własnej marki (podstawa prawna art. 6 ust. 1 lit. f Rozporządzenia). Dane mogą być też przetwarzane w celu badania satysfakcji Użytkowników i określania jakości usług Administratora. Podstawą prawną przetwarzania jest prawnie uzasadniony interes polegający na uzyskaniu stosownych informacji w celu polepszenia jakości produktów i usług Administratora (art. 6 ust. 1 lit. f) Rozporządzenia).
      </p>
      <p>
        Podanie Danych osobowych przez Użytkownika nie jest wymogiem ustawowym lub
        umownym, nie jest też warunkiem zawarcia umowy, ale brak podania Danych osobowych
        uniemożliwia korzystanie z niektórych funkcjonalności dostępnych na profilach
        Administratora w mediach społecznościowych.
      </p>
      <p>
        Użytkownicy mogą uzyskać dalsze informacje na temat przetwarzania Danych osobowych
        na profilach Administratora w poszczególnych mediach społecznościowych. Informacje
        zawarte w niniejszym pkt. III.5. nie dotyczą przetwarzania Danych osobowych przez
        administratorów w/w serwisów (mediów społecznościowych); dane na ten temat
        Użytkownik może znaleźć w dokumentach dotyczących prywatności udostępnianych przez
        te podmioty w tych serwisach.
      </p>

      <p>
        <span class="font-bold">III.6. </span> <u>Przetwarzanie danych Użytkownika, który kontaktuje się z Administratora za
        pośrednictwem e-maila lub poczty tradycyjnej lub telefonicznie w innych sprawach, niż
        korzystanie z Serwisu:</u> Dane osobowe są co do zasady dostarczane przez Użytkownika w
        sposób bezpośredni i typowo informacje te obejmują imię i nazwisko, adres e-mail, pozostałe
        dane teleadresowe, inne dane podane przez Użytkownika, przy czym w przypadku kontaktu
        telefonicznego Administrator automatycznie pozyskuje również numer telefonu, z którego
        wykonywane jest połączenie.<br>
        Dane osobowe zawarte w korespondencji skierowanej przez Użytkownika do Administratora są przetwarzane wyłącznie w celu komunikacji i rozwiązania sprawy, której dotyczy korespondencja/komunikacja. Dane osobowe są przetwarzane na podstawie art. 6 ust. 1 lit. f) Rozporządzenia - przetwarzanie jest niezbędne do celów wynikających z prawnie uzasadnionych interesów realizowanych przez Administratora polegających na prowadzeniu korespondencji kierowanej do niego w związku z jego działalnością gospodarczą. Dane mogą być też przetwarzane w oparciu o podstawy wskazane w pkt. III.2. – III.5., jeśli Użytkownik kontaktuje się z Administratorem w sprawach w nich opisanych.
      </p>
      <p>
        Podanie Danych osobowych przez Użytkownika nie jest wymogiem ustawowym lub
        umownym, nie jest też warunkiem zawarcia umowy, ale brak podania Danych osobowych
        uniemożliwia kontakt z Administratorem lub odpowiedź Administratora na korespondencję
        skierowaną przez Użytkownika.
      </p>
      <p>
        <span class="font-bold">III.7. </span>
        <u>Przetwarzanie Danych osobowych Użytkowników na innych podstawach:</u>
        Administrator może przetwarzać Dane osobowe Użytkowników na podstawie zgody wyrażonej przez Użytkownika, w każdym razie w zakresie, w celach, na zasadach i przez okres w niej określonych.
      </p>
      <p>
        <span class="font-bold">III.8. </span> Administrator nie przetwarza na podstawie art. 6 ust. 1 lit. f Rozporządzenia Danych osobowych dzieci.
      </p>

      <h4>IV. PLIKI COOKIES</h4>

      <p><span class="font-bold">IV.1.</span> Pliki cookies (tzw. ciasteczka) stanowią dane informatyczne, w szczególności pliki
        tekstowe, które przechowywane są w urządzeniu końcowym Użytkownika Serwisu i
        przeznaczone są do korzystania ze stron internetowych Serwisu. Pliki cookies zazwyczaj
        zawierają nazwę strony internetowej, z której pochodzą, czas przechowywania ich na
        urządzeniu końcowym oraz unikalny numer. Pliki cookies zbierają informacje ułatwiające
        korzystanie ze strony internetowej.

        <p>Pliki cookies wykorzystywane są w Serwisie w celu:</p>
        <div>
          <p>
            <span class="font-bold">a)</span> utrzymania sesji Użytkownika Serwisu (po zalogowaniu do Profilu), dzięki której
            Użytkownik nie musi na każdej podstronie Serwisu ponownie wpisywać loginu i hasła;
            te pliki cookies służą do identyfikowania zalogowanego Użytkownika.
          </p>
        </div>
      </p>
      <p><span class="font-bold">IV.2.</span> W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików cookies: sesyjne
      (session cookies) oraz stałe (persistent cookies). Pliki cookies sesyjne są plikami
      tymczasowymi, które przechowywane są w urządzeniu końcowym Użytkownika do czasu
      wylogowania, opuszczenia strony internetowej lub wyłączenia oprogramowania
      (przeglądarki internetowej). Stałe pliki cookies przechowywane są w urządzeniu końcowym
      Użytkownika przez czas określony w parametrach plików cookies lub do czasu ich usunięcia
      przez Użytkownika.</p>
      <p>
      Administrator wykorzystuje następujące pliki cookies:
      </p>
      <div>
        <p>
        <span class="font-bold">a)</span> „niezbędne” pliki cookies, umożliwiające korzystanie z usług dostępnych w ramach
        Serwisu, np. uwierzytelniające pliki cookies wykorzystywane do usług wymagających
        uwierzytelniania w ramach Serwisu;
        </p>
        <p>
        <span class="font-bold">b)</span> pliki cookies służące do zapewnienia bezpieczeństwa, np. wykorzystywane do
        wykrywania nadużyć w zakresie uwierzytelniania w ramach Serwisu;
        </p>
      </div>
      <p><span class="font-bold">IV.3.</span> Wykorzystanie plików cookies w celu zbierania za ich pośrednictwem danych, w tym
      uzyskania dostępu do danych zapisanych na urządzeniu Użytkownika, wymaga uzyskania
      zgody Użytkownika. Zgoda ta może być w każdym momencie wycofana. Zgoda nie jest
      wymagana jedynie w przypadku plików cookies, których stosowanie jest niezbędne do
      świadczenia usługi telekomunikacyjnej (transmisja danych w celu wyświetlenia treści).
      </p>
      <p>
      W wielu przypadkach oprogramowanie służące do przeglądania stron internetowych
      (przeglądarka internetowa) domyślnie dopuszcza przechowywanie plików cookies w
      urządzeniu końcowym Użytkownika. Użytkownicy Serwisu mogą dokonać w każdym czasie
      zmiany ustawień dotyczących plików cookies lub wycofać swoja zgodę w tym zakresie.
      Ustawienia te mogą zostać zmienione w szczególności w taki sposób, aby blokować
      automatyczną obsługę plików cookies w ustawieniach przeglądarki internetowej bądź
      informować o ich każdorazowym zamieszczeniu w urządzeniu Użytkownika Serwisu.
      </p>
      <p>
      Szczegółowe informacje o możliwości i sposobach obsługi plików cookies dostępne są w
      ustawieniach oprogramowania (przeglądarki internetowej):
      </p>
      <div>
        <p>
          <span class="font-bold">a) </span>
            <a
              href="https://support.microsoft.com/pl-pl/help/17442/windows-internetexplorer-delete-manage-cookies"
            >Internet Explorer</a>
          </p>
          <p>
            <span class="font-bold">b) </span>
            <a
              href="http://support.mozilla.org/pl/kb/ciasteczka"
            >Mozilla Firefox</a>
          </p>
          <p>
            <span class="font-bold">c) </span>
            <a
              href="http://support.google.com/chrome/bin/answer.py?hl=pl&answer=95647"
            >Google Chrome</a>
          </p>
          <p>
            <span class="font-bold">d) </span>
            <a
              href="http://help.opera.com/Windows/12.10/pl/cookies.html"
            >Opera</a>
          </p>
          <p>
            <span class="font-bold">e) </span>
            <a
              href="https://support.apple.com/kb/PH5042?locale=en-GB"
            >Safari</a>
          </p>
      </div>
      <p>
      Ograniczenia stosowania plików cookies mogą wpłynąć na niektóre funkcjonalności
      dostępne na stronach internetowych Serwisu.
      </p>
      <p>
      Pliki cookies zamieszczane w urządzeniu końcowym Użytkownika Serwisu wykorzystywane
      mogą być również przez współpracujących z Administratorem reklamodawców oraz
      partnerów.,.
      </p>


      <h4>V. OKRES PRZETWARZANIA DANYCH OSOBOWYCH</h4>

      <p><span class="font-bold">V.1.</span> Okres przetwarzania Danych osobowych przez Administratora zależy od rodzaju
      świadczonej usługi za pośrednictwem Serwisu, jak również od celu przetwarzania tych
      Danych. Co do zasady dane przetwarzane są przez czas świadczenia usługi świadczonej
      drogą elektroniczną na podstawie Regulaminu, do czasu wycofania wyrażonej zgody (jeśli
      przetwarzanie Danych osobowych odbywa się na podstawie zgody) lub przez okres w tej
      zgodzie określony lub do czasu zgłoszenia skutecznego sprzeciwu względem przetwarzania
      Danych osobowych (w przypadkach, gdy podstawą prawną przetwarzania Danych
      osobowych jest prawnie uzasadniony interes Administratora oraz marketing bezpośredni).
      Okres przetwarzania Danych osobowych może być przedłużony w przypadku, gdy
      przetwarzanie jest niezbędne do ustalenia i dochodzenia ewentualnych roszczeń lub obrony
      przed roszczeniami, a po tym czasie jedynie w przypadku i w zakresie, w jakim będą
      wymagać tego przepisy prawa. Po upływie okresu przetwarzania Dane osobowe są
      nieodwracalnie usuwane lub anonimizowane.</p>

      <p>Powyższe, jak również postanowienia pkt VI i VII poniżej, dotyczy przetwarzania Danych
      osobowych przez Administratora działającego jako administrator danych osobowych w
      rozumieniu Rozporządzenia. W zakresie Danych osobowych przetwarzanych przez
      Administratora w imieniu Szkoły, obowiązujące są informacje zawarte w klauzulach
      informacyjnych przekazywanych przez Szkołę, w szczególności w trakcie procesu zawierania
      przez Użytkownika umowy o przeprowadzenie kursu językowego.</p>


      
      <h4>VI. UPRAWNIENIA UŻYTKOWNIKA</h4>

      <p><span class="font-bold">VI.1.</span> Użytkownik ma prawo:</p>
      <div>
        <p><span class="font-bold">a)</span> w dowolnym momencie wycofać zgodę na przetwarzanie Danych osobowych, o ile
        przetwarzanie dobywa się na podstawie zgody, przy czym wycofanie zgody nie
        wpływa na zgodność z prawem przetwarzania, którego dokonano na podstawie
        zgody przed jej wycofaniem;</p>
        <p><span class="font-bold">b)</span> żądania od Administratora dostępu do podanych Danych osobowych, ich
        sprostowania, usunięcia („prawo do bycia zapomnianym”) lub ograniczenia przetwarzania, a także prawo do przenoszenia danych do innego administratora;</p>
        <p><span class="font-bold">c)</span> wniesienia skargi do organu nadzorczego, do którego kompetencji należy kontrola
        nad zgodnością z prawem przetwarzania danych osobowych, tj. Prezesa Urzędu Ochrony Danych Osobowych.</p>
      </div>

      <p><span class="font-bold">VI.2.</span> Użytkownik ma również prawo wniesienia sprzeciwu wobec przetwarzania danych
      osobowych dla celów marketingowych, jeśli przetwarzanie odbywa się w związku z prawnie
      uzasadnionym interesem Administratora, a także – z przyczyn związanych ze szczególną
      sytuacją Użytkownika – w innych przypadkach, gdy postawą prawną przetwarzania danych
      jest prawnie uzasadniony interes Administratora.
      </p>

      <p><span class="font-bold">VII.3.</span> Realizacja wskazanych powyżej praw, poza wniesieniem skargi do organu
      nadzorczego, może odbywać się poprzez wskazanie swoich żądań i przesłanie ich na adres
      e-mail: <a href="mailto:d.osobowe@earlystage.pl">d.osobowe@earlystage.pl</a> lub w inny wybrany przez Użytkownika sposób.
      </p>

      <h4>VII. PRZEKAZYWANIE DANYCH</h4>

      <p><span class="font-bold">VII.1.</span> W związku z realizacją usług świadczonych za pośrednictwem Serwisu, Dane osobowe
      będą ujawniane zewnętrznym podmiotom, w tym w szczególności dostawcom odpowiedzialnym za obsługę systemów informatycznych oraz podmiotom powiązanym z Administratorem, w tym spółkom z jego grupy kapitałowej, zgodnie z zawartymi z takimi podmiotami umowami powierzenia przetwarzania danych osobowych. Administrator informuje również, że dane osobowe mogą być przetwarzane przy pomocy usług podmiotów
      trzecich (procesorów) wraz z przekazywania tych Danych osobowych do państwa spoza Europejskiego Obszaru Gospodarczego. Przekazanie takie jest realizowane jeśli procesor powołuje się w swoich politykach prywatności lub innych zasadach dotyczących ochrony
      danych osobowych na wynikające z Rozporządzenia podstawy, w szczególności standardowe klauzule ochrony danych przyjęte przez Komisję Europejską, czy stosowanie wiążących reguł korporacyjnych, zatwierdzonych przez właściwy organ nadzorczy. Administrator wymaga od tych podmiotów będących procesorami Danych osobowych zgodnego z przepisami prawa stopnia ochrony prywatności i bezpieczeństwa danych
      osobowych przetwarzanych przez te podmioty.</p>
      
      <p><span class="font-bold">VII.2.</span> Administrator ma prawo ujawnienia określonych informacji dotyczących Użytkownika
      właściwym organom bądź osobom trzecim, które zgłoszą żądanie udzielenia takich
      informacji, zawsze działając zgodnie z przepisami obowiązującego prawa.</p>

      <p><span class="font-bold">VII.3.</span> W przypadku uzyskania stosownej zgody Użytkownika jego dane mogą zostać także
      udostępnione innym podmiotom do ich własnych celów, w tym celów marketingowych.</p>


      <h4>VIII. BEZPIECZEŃSTWO DANYCH OSOBOWYCH</h4>

      <p><span class="font-bold">VIII.1.</span> Administrator na bieżąco prowadzi analizę ryzyka w celu zapewnienia, że Dane
      osobowe przetwarzane są w sposób bezpieczny. Dostęp do Danych osobowych mają jedynie
      osoby upoważnione i jedynie w zakresie, w jakim jest to niezbędne ze względu na cel
      przetwarzania i ze względu na wykonywane przez nie zadania. Wszystkie operacje na
      Danych osobowych są odpowiednio rejestrowane i dokonywane jedynie przez uprawnione
      osoby.</p>


      <h4>IX. POSTANOWIENIA KOŃCOWE</h4>

      <p><span class="font-bold">IX.1.</span> Każdy Użytkownik może skontaktować się Administratorem korzystając z danych
      kontaktowych wskazanych w pkt II.2. powyżej. Odpowiedź będzie udzielana na adres e-mail,
      z którego przesłano wniosek/zapytanie/żądanie, a w przypadku wniosków/zapytań/żądań
      skierowanych listownie, listem zwykłym na adres wskazany przez wnioskodawcę, o ile z treści
      listu nie będzie wynikała chęć otrzymania informacji zwrotnej na adres e-mail (w takim
      przypadku należy podać adres e-mail).</p>
      
      <p><span class="font-bold">IX.2.</span> Administrator będzie dokonywał bieżących przeglądów niniejszej Polityki prywatności
      i w razie potrzeby ją modyfikował i aktualizował.
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PrivacyPolicy',
};
</script>

<style lang="scss" scoped>
.privacy_policy {
  &__title {
    @apply text-center font-bold text-2xl block my-3 px-3 pb-2;
    @media screen and (min-width: 768px) {
      @apply text-4xl pb-6;
    }
    @media screen and (min-width: 1600px) {
      @apply pb-8;
    }
  }
  &__content {
    @apply leading-normal text-base px-3 text-center mb-3;
    height: 60vh;
    overflow-y: scroll;
    @media screen and (min-width: 370px) {
      height: 65vh;
    }
    @media screen and (min-width: 768px) {
      @apply text-xl px-8;
    }
    h4 {
      @apply font-bold py-5;
    }
    p {
      @apply py-4;
    }
  }
}
</style>
